export class SecretRefInputGcp {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceName",
            "baseName": "resourceName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SecretRefInputGcp.attributeTypeMap;
    }
    constructor() {
    }
}
